import {
  FDConfirmationDialog,
  FDListItem,
  FDListItemIcon,
  FDListItemSecondary,
  FDListItemText,
  FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import Divider from 'Components/UI/Divider';
import React from 'react';
import { useAuthenticationFactorListContext } from 'Organisms/AuthenticationFactorList/AuthenticationFactorListContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import {
  dataAttrs,
} from 'Helpers/Testing';


export const AuthenticationFactorItem = ({ afi }) => {
  const { refreshListCollection } = useAuthenticationFactorListContext();
  const { handleInterceptResponse } = useIdentityChallengeContext();
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();

  // Deleting an auth factor item may return a DICRs challenge response so we must intercept that response here
  const onSubmitSuccess = (possiblyDicrsResponse) => {
    return handleInterceptResponse(possiblyDicrsResponse, (originalRequestResponse) => {
      displaySuccess('Successfully deleted');
      refreshListCollection();
      return originalRequestResponse;
    });
  };

  const handleDelete = async () => {
    const relationship = afi.relationship(fr.relationships.remove.name);
    if (!relationship) {
      return;
    }
    try {
      const res = await relationship.link('related').delete();
      onSubmitSuccess(res);
      dispatchAuthenticationFactorsRefresh();
    } catch (err) {
      displayErrorMessage(err, err.message || 'Unable to delete');
    }
  };

  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    onSubmit: handleDelete,
    closeOnSubmit: true,
  });

  return (
    <>
      <FDListItem {...dataAttrs('authentication-factor-list-item', afi)}>
        <FDListItemIcon icon={afi.attr('icon')} />
        <FDListItemText primaryText={afi.attr('title')} secondaryText={afi.attr('description')} />
        {afi.withRelationship(fr.relationships.remove.name,
          (rel) => (
            <FDListItemSecondary>
              <FDSecondaryActionIconButton
                {...dataAttrs('passkey-delete-btn', afi)}
                icon={rel.meta('icon')}
                label={rel.meta('prompt')}
                onClick={handleOpen}
                disabled={rel.meta('disabled') || false}
              />
            </FDListItemSecondary>),
          () => null)}
      </FDListItem>
      <Divider />
      <FDConfirmationDialog
        {...dataAttrs('passkey-delete-confirm-dialog', afi)}
        open={dialogOpen}
        message={'Are you sure you want to remove this passkey? This cannot be undone.'}
        title={'Are you sure?'}
        onClose={handleClose}
        onConfirm={handleSubmit}
        loading={loading}
      />
    </>
  );
};
